export default {"src":"/_next/static/media/heart.9bbfeddf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};